import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { IRole } from './roles.interface';
import { RolesService } from './roles.service';
import { RolesModalComponent } from './roles-modal/roles-modal.component';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {
  roles: IRole[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: any = {
    "name": 'Nombre asc',
    "-name": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev: any;

  constructor(
    private _RoleService: RolesService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService,
    private router: Router
  ) {
    self = this;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.getRoles(true);
  }

  getRoles(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.roles = [];
      this.clearSelection();
    }
    this._RoleService.getRoles(this.filter).subscribe((roles: any) => {
      this.roles = _.concat(this.roles, roles);
      const filter: any = this.filter;
      this.thereAreMore = roles.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getRoles();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortRoles(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getRoles(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  openNewRoleModal() {
    this.openRoleModal({});
  }

  openRoleModal(role: IRole, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef; 
    self.dialogRef = this._dialog.open(RolesModalComponent, config);
    self.dialogRef.componentInstance.role = role;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getRoles(true);
    });
  }

  openDeleteRoleConfirm(role: IRole, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Moneda",
      message: "Esta seguro que desea eliminar '" + role.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._RoleService.deleteRole(role, hardDelete).subscribe(() => {
            if (hardDelete) this.getRoles(true);
            else role.isDeleted = true;
          })
        }
      });
  }

  openRestoreRoleConfirm(role: IRole) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Moneda",
      message: "Esta seguro que desea restaurar '" + role.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._RoleService.restoreRole(role).subscribe(() => {
            role.isDeleted = false;
          })
        }
      });
  }

  openExportItems(all: boolean) {
    this.openUnderConstructionDialog();
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.roles.every(role => {
        const id = role?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.roles.forEach(role => {
        const id = role?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}